export const ACCOUNT_STATE = ["trial", "active", "past_due", "suspended", "closed", "closing"];
/**
 * `member_role`.
 *
 * DISAGREEMENT, now CLOSED (P7, 2026-09-22) in favour of this type. Product decision Q10
 * answers "**Owner / Admin / Member / Viewer**" and is binding; design 4.1 shipped a
 * three-value `CREATE TYPE member_role AS ENUM ('owner','admin','member')`, which made
 * `viewer` unrepresentable in the database. Design 4.1 was amended to four values and
 * 14.4 C-d / 14.5 U8 were marked resolved.
 *
 * **P2 owns the migration and must create the enum with all four values in the first one.**
 * `viewer` is read-only — analytics and outcomes, never VoiceAgent configuration — and is
 * deliberately absent from `RECORDING_VISIBLE_ROLE` below (AC-33).
 */
export const MEMBER_ROLE = ["owner", "admin", "member", "viewer", "developer", "campaign_manager", "billing"];
/** The four roles of product decision Q10 — what existed before plan-014's presets, in their order. */
export const LEGACY_MEMBER_ROLE = ["owner", "admin", "member", "viewer"];
/** The roles design 4.2's `recording_visible` view admits. Members never see recordings. */
export const RECORDING_VISIBLE_ROLE = ["owner", "admin"];
/** The literal segment used in place of `{workspace_id}` for account-scoped blobs. */
export const ACCOUNT_SCOPED_SEGMENT = "_account";
//# sourceMappingURL=account.js.map